import React from 'react';

function VehicleDetailsCard({ vehicle }: any) {
console.log("vehicle ==> ", vehicle);
  return (
    <div className="card mt-4 p-4">
      <h5>Vehicle Details</h5>
      <p><strong>Vehicle Name:</strong> {vehicle?.vehicle_name || 'N/A'}</p>
      <p><strong>Vehicle Model:</strong> {vehicle?.vehicle_model || 'N/A'}</p>
      <p><strong>Registration Number:</strong> {vehicle?.label || 'N/A'}</p>
      <p><strong>Xen:</strong> {vehicle?.xen?.user_name || 'N/A'}</p>
      <p><strong>Aen:</strong> {vehicle?.aen?.user_name || 'N/A'}</p>
      <p><strong>Jen:</strong> {vehicle?.jen?.user_name || 'N/A'}</p>
      <p><strong>Vendor:</strong> {vehicle?.vehicle_vendor?.vendor?.user_name || 'N/A'}</p>
      <p><strong>Driver:</strong> {vehicle?.vehicle_driver?.driver?.name || 'N/A'}</p>
    </div>
  );
}

export default VehicleDetailsCard;